import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createSlots as _createSlots, createVNode as _createVNode, Teleport as _Teleport, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-9957f9c0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "common-upload"
};
const _hoisted_2 = {
  class: "upload-label"
};
const _hoisted_3 = {
  key: 1,
  class: "el-upload__text"
};
const _hoisted_4 = {
  class: "picture-template"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = ["onClick"];
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "el-upload__tip"
};
const _hoisted_9 = {
  key: 0,
  class: "pre-box"
};
const _hoisted_10 = {
  class: "pre-box-content"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  class: "operation-box"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "operation-box_line"
}, "|", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_upload = _resolveComponent("el-upload");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$attrs.uploadLabel), 1), _createVNode(_component_el_upload, _mergeProps({
    class: {
      'upload-demo-drag': _ctx.isClassDrag,
      'upload-demo': !_ctx.isClassDrag
    },
    action: $setup.uploadAction,
    headers: _ctx.headers,
    "on-preview": $setup.handlePreview,
    "on-success": $setup.handleSuccess,
    name: "src",
    data: {
      dir: _ctx.dir
    },
    "on-remove": $setup.handleRemove
  }, _ctx.$attrs, {
    "on-progress": $setup.handleProgress,
    multiple: "",
    "on-exceed": $setup.handleExceed
  }), _createSlots({
    tip: _withCtx(() => [_createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$attrs.uploadTip), 1)]),
    default: _withCtx(() => [!_ctx.$attrs.drag ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      type: "primary"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('other.upload')), 1)]),
      _: 1
    })) : _createCommentVNode("", true), _ctx.$attrs.drag ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createTextVNode(_toDisplayString(_ctx.$t('outwarehouse.Draggable_or_clickable')), 1), _createElementVNode("em", null, _toDisplayString(_ctx.$t('other.upload_files')), 1)])) : _createCommentVNode("", true)]),
    _: 2
  }, [_ctx.$attrs.listType === 'picture' ? {
    name: "file",
    fn: _withCtx(({
      file
    }) => [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
      class: "el-upload-list__item-thumbnail",
      src: file.url || file.src,
      alt: ""
    }, null, 8, _hoisted_5), _createElementVNode("p", {
      class: "picture-template-name",
      onClick: $event => $setup.handlePreview(file)
    }, _toDisplayString(file.name), 9, _hoisted_6), _createElementVNode("span", {
      class: "picture-template-close",
      onClick: $event => $setup.handleRemove(file)
    }, "x", 8, _hoisted_7)])]),
    key: "0"
  } : undefined]), 1040, ["class", "action", "headers", "on-preview", "on-success", "data", "on-remove", "on-progress", "on-exceed"])]), (_openBlock(), _createBlock(_Teleport, {
    to: "html"
  }, [_ctx.isPre ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("img", {
    src: _ctx.preUrl,
    alt: ""
  }, null, 8, _hoisted_11), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", {
    class: "operation-box_close",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.isPre = false)
  }, _toDisplayString(_ctx.$t('other.Close')), 1), _hoisted_13, _createElementVNode("div", {
    class: "operation-box_download",
    onClick: _cache[1] || (_cache[1] = (...args) => $setup.downloadPic && $setup.downloadPic(...args))
  }, _toDisplayString(_ctx.$t('other.download')), 1)])])])) : _createCommentVNode("", true)]))], 64);
}